import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinTripTimeIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C8.141 2 5 5.14 5 9C5 13.068 9.63333 19.5841 11.3613 21.7031C11.6903 22.1071 12.3087 22.1071 12.6387 21.7031C14.3657 19.5841 19 13.068 19 9C19 5.14 15.859 2 12 2ZM12 4C14.757 4 17 6.243 17 9C17 11.757 14.757 14 12 14C9.243 14 7 11.757 7 9C7 6.243 9.243 4 12 4Z"
      fill={props.sx?.color || '#080F1D'}
    />
    <path
      d="M12 9V6C10.3313 6 9 7.3313 9 9C9 10.6687 10.3313 12 12 12C13.6687 12 15 10.6687 15 9H12Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinTripTimeIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinTripTimeIcon;
